document.addEventListener("DOMContentLoaded", function () {
  var toggleBtn = document.getElementById("read-more-toggle");
  var desc = document.getElementById("collection-description");

  if (toggleBtn && desc) {
    toggleBtn.addEventListener("click", function () {
      desc.classList.toggle("expanded");
      toggleBtn.textContent = desc.classList.contains("expanded") ? "Read less" : "Read more";

      // Scroll so the top of the description is visible after expanding/collapsing
      desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});

